import React, { Component, Fragment } from 'react';

import WebAppProjects from '../components/projects/webAppProjects';
import ResponsiveAppBar from '../components/components/appbar';
import ResponsiveFooter from '../components/components/footer';

class WebAppProject extends Component {

    render() {
        return (
            <Fragment>
                <ResponsiveAppBar />
                <div className="pageHeight">
                    <WebAppProjects />
                </div>
                <ResponsiveFooter />
            </Fragment>
        );
    };
};

export default WebAppProject;